module.exports = __webpack_public_path__ + "static/img/img-cp8.c480b2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp8.png
// module id = xrEl
// module chunks = 0